import * as Yup from 'yup';

import { NO_LEADING_TRAILING_SPACES_VALIDATION } from '@/shared/consts';

export const SKILL_VALIDATION_SCHEMA = Yup.object().shape({
  title: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    200,
    'Превышено допустимое количество символов',
  ),
  description: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    500,
    'Превышено допустимое количество символов',
  ),
});
